module.exports = __webpack_public_path__ + "static/img/11.f154723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/11.png
// module id = 189
// module chunks = 1